import { FetchLanguageFile } from 'Services';
import enOriginalData from 'utils/vernacular/en_original.json';

const TRANSLATIONS_HI = '/translations/locale/hi.json';
const TRANSLATIONS_BN = '/translations/locale/bn_IN.json';
const TRANSLATIONS_GJ = '/translations/locale/gu_IN.json';
const TRANSLATIONS_KN = '/translations/locale/kn.json';
const TRANSLATIONS_ML = '/translations/locale/ml.json';
const TRANSLATIONS_MR = '/translations/locale/mr.json';
const TRANSLATIONS_TE = '/translations/locale/te.json';
const TRANSLATIONS_TA = '/translations/locale/ta_IN.json';

export const GetLanguageConfig = async (lang?: string): Promise<Record<string, string>> => {
	try {
		switch (lang) {
			case 'bn':
				return setDefaultValueForEmpty(await FetchLanguageFile(TRANSLATIONS_BN));
			case 'gu':
				return setDefaultValueForEmpty(await FetchLanguageFile(TRANSLATIONS_GJ));
			case 'hi':
				return setDefaultValueForEmpty(await FetchLanguageFile(TRANSLATIONS_HI));
			case 'kn':
				return setDefaultValueForEmpty(await FetchLanguageFile(TRANSLATIONS_KN));
			case 'ml':
				return setDefaultValueForEmpty(await FetchLanguageFile(TRANSLATIONS_ML));
			case 'mr':
				return setDefaultValueForEmpty(await FetchLanguageFile(TRANSLATIONS_MR));
			case 'ta':
				return setDefaultValueForEmpty(await FetchLanguageFile(TRANSLATIONS_TA));
			case 'te':
				return setDefaultValueForEmpty(await FetchLanguageFile(TRANSLATIONS_TE));
			default:
				return getDefaultLanguageConfig();
		}
	} catch (e) {
		return getDefaultLanguageConfig();
	}
};

export const getDefaultLanguageConfig = (): Record<string, string> => {
	return enOriginalData;
};

/**
 * Backfill empty keys from default language.
 *
 * @param data Selected local language data.
 * @returns language data with backfill empty keys.
 */
export const setDefaultValueForEmpty = (data: Record<string, string>): Record<string, string> => {
	const originalLang = getDefaultLanguageConfig();
	const keys = Object.keys(data);
	const finalData: Record<string, string> = {};
	for (const key of keys) {
		finalData[key] = data[key] === '' || typeof data[key] === 'undefined' ? originalLang[key] : data[key];
	}

	return finalData;
};
